import { useEffect } from 'react';

import { SignInForm } from 'features/auth';
import { Analytics } from 'features/analytics';

import styles from './index.module.scss';


export const SignIn = () => {
	useEffect(() => {
		Analytics.trackSigninPageView();
	})

	return (
		<section className={styles.container}>
			<main className={styles.login}>
				<SignInForm className={styles.login} />
			</main>
			<section className={styles.image}></section>
		</section>
	);
};
